import * as t from 'io-ts';
import { fromEnum } from '../../responseUtil';

export enum ApiIncomingVehicleSort {
    EXPECTED_ARRIVAL_AT_ASC = '+expected_arrival_at',
    EXPECTED_ARRIVAL_AT_DESC = '-expected_arrival_at',
    LOCATION_IDENTIFIER_ASC = '+location_identifier',
    LOCATION_IDENTIFIER_DESC = '-location_identifier',
    FREIGHT_FORWARDER_ASC = '+freight_forwarder',
    FREIGHT_FORWARDER_DESC = '-freight_forwarder',
}

export enum ApiInventoryVehicleSort {
    ARRIVAL_COMPLETED_AT_ASC = '+arrival_completed_at',
    ARRIVAL_COMPLETED_AT_DESC = '-arrival_completed_at',
    LOCATION_IDENTIFIER_ASC = '+location_identifier',
    LOCATION_IDENTIFIER_DESC = '-location_identifier',
    FREIGHT_FORWARDER_ASC = '+freight_forwarder',
    FREIGHT_FORWARDER_DESC = '-freight_forwarder',
}

export enum ApiOutgoingVehicleSort {
    EXPECTED_DEPARTURE_AT_ASC = '+expected_departure_at',
    EXPECTED_DEPARTURE_AT_DESC = '-expected_departure_at',
    LOCATION_IDENTIFIER_ASC = '+location_identifier',
    LOCATION_IDENTIFIER_DESC = '-location_identifier',
    FREIGHT_FORWARDER_ASC = '+freight_forwarder',
    FREIGHT_FORWARDER_DESC = '-freight_forwarder',
}

export enum ApiDepartedVehicleSort {
    ARRIVAL_COMPLETED_AT_ASC = '+arrival_completed_at',
    ARRIVAL_COMPLETED_AT_DESC = '-arrival_completed_at',
    DEPARTURE_COMPLETED_AT_ASC = '+departure_completed_at',
    DEPARTURE_COMPLETED_AT_DESC = '-departure_completed_at',
    LOCATION_IDENTIFIER_ASC = '+location_identifier',
    LOCATION_IDENTIFIER_DESC = '-location_identifier',
    ARRIVAL_FREIGHT_FORWARDER_ASC = '+arrival_freight_forwarder',
    ARRIVAL_FREIGHT_FORWARDER_DESC = '-arrival_freight_forwarder',
    DEPARTURE_FREIGHT_FORWARDER_ASC = '+departure_freight_forwarder',
    DEPARTURE_FREIGHT_FORWARDER_DESC = '-departure_freight_forwarder',
}

export enum ApiCompoundVehicleType {
    INCOMING = 'incoming',
    IN_INVENTORY = 'in-inventory',
    OUTGOING = 'outgoing',
    DEPARTED = 'departed',
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const CompoundVehicleExportQueryParameterCodec = t.partial({
    location: t.string,
    compound_vehicle_type: t.array(fromEnum<ApiCompoundVehicleType>('ApiCompoundVehicleType', ApiCompoundVehicleType)),
});

export type ApiCompoundVehicleExportQueryParameter = t.TypeOf<typeof CompoundVehicleExportQueryParameterCodec>;
